import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getDevicesAPI() {
  const url = `${AWS_API_URL}/2n/devices`;
  return getRequest(url, await authorize());
}

